/**
 * @fileoverview HelpButton — default trigger for HelpPopover. A minimal, small
 * Blueprint Button with the `help` icon. Lives in the rail footer next to the
 * principal-avatar UserMenu. When wrapped as a Popover child, Blueprint wires
 * the open/close handlers automatically; `onClick` is exposed for compositions
 * that override the trigger.
 *
 * Foundry mapping: the `bp6-button bp6-minimal` help glyph in the
 * workspace-sidebar footer that anchors the `bp6-popover-placement-right`
 * help menu.
 */

import { Button } from "@blueprintjs/core";
import type { ReactElement } from "react";

interface HelpButtonProps {
  onClick?: () => void;
  className?: string;
}

export function HelpButton({ onClick, className }: HelpButtonProps): ReactElement {
  return (
    <Button data-testid="help-button"
      minimal
      small
      icon="help"
      aria-label="Help"
      title="Help"
      onClick={onClick}
      className={["bp-help-button", className].filter(Boolean).join(" ")}
    />
  );
}
